import React, { ReactElement, ReactNode } from 'react';

import { Loader } from 'component/Loader/Loader';
import { LoadingStateEnum, Resource } from 'model/Resource';

export type ResourceLoaderNewProps<T = any> = {
  resource: Resource<T> | Resource[];
  children: (data: T) => ReactNode;
  rejected?: (error: Error | null) => ReactElement;
  hideLoader?: boolean;
};

export const ResourceLoader: React.FC<ResourceLoaderNewProps> = ({
  resource,
  rejected,
  children,
  hideLoader = false,
}) => {
  const resources = Array.isArray(resource) ? resource : [resource];
  const pendingResource = resources.find((res) => res.loadingState === LoadingStateEnum.PENDING);
  const rejectedResource = resources.find((res) => res.loadingState === LoadingStateEnum.REJECTED);
  const hasAllResourcesResolved =
    resources.length ===
    resources.filter((res) => res.loadingState === LoadingStateEnum.RESOLVED).length;

  const shouldShowLoader = !hideLoader && pendingResource;

  return (
    <>
      {!rejectedResource && shouldShowLoader && <Loader />}
      {!rejectedResource &&
        hasAllResourcesResolved &&
        children(Array.isArray(resource) ? resources.map((r) => r.data) : resource.data)}
      {rejectedResource &&
        (rejected?.(rejectedResource.error) ?? <span>Cannot load resource.</span>)}
    </>
  );
};
